import React from 'react';
import Spinner from '@atlaskit/spinner';

export default () => {
  return <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
    <Spinner />
  </div>
}